export function episodeDurationParts(duration: unknown): {
  mm: string;
  ss: string;
} {
  if (duration == null || duration === "") return { mm: "", ss: "" };

  if (typeof duration === "object") {
    const obj = duration as { minutes?: number; seconds?: number };
    if (obj.minutes != null || obj.seconds != null) {
      return {
        mm: String(obj.minutes ?? 0),
        ss: String(obj.seconds ?? 0),
      };
    }
    return { mm: "", ss: "" };
  }

  if (typeof duration !== "string") return { mm: "", ss: "" };

  const trimmed = duration.trim();
  const clock = trimmed.match(/^(?:(\d+)\s+)?(\d+):(\d+):(\d+)/);
  if (clock) {
    const days = Number(clock[1] ?? 0);
    const hours = Number(clock[2]);
    const minutes = Number(clock[3]);
    const seconds = Number(clock[4]);
    return {
      mm: String(days * 24 * 60 + hours * 60 + minutes),
      ss: String(seconds),
    };
  }

  const minutesAndSeconds = trimmed.match(/^(\d+):(\d+)$/);
  if (minutesAndSeconds) {
    return {
      mm: String(Number(minutesAndSeconds[1])),
      ss: String(Number(minutesAndSeconds[2])),
    };
  }

  return { mm: "", ss: "" };
}

export function episodeDurationValue(
  minutes: number,
  seconds: number
): `${number}:${number}:${number}` {
  const safeMinutes = Number.isFinite(minutes) ? Math.max(0, Math.floor(minutes)) : 0;
  const safeSeconds = Number.isFinite(seconds) ? Math.max(0, Math.floor(seconds)) : 0;
  const hours = Math.floor(safeMinutes / 60);
  const remainingMinutes = safeMinutes % 60;
  const clock = [hours, remainingMinutes, safeSeconds]
    .map((part) => String(part).padStart(2, "0"))
    .join(":");
  return clock as `${number}:${number}:${number}`;
}
